var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MzSelect',{staticClass:"mb-3 mt-2 select-member",attrs:{"searchable":"","options":_vm.members,"value":_vm.member_id},on:{"update:value":[function($event){_vm.member_id=$event},(v) => _vm.updateMember(v)]}})
}
var staticRenderFns = []

export { render, staticRenderFns }